// extracted by mini-css-extract-plugin
module.exports = {"productCell":"product-cell_productCell_2e330","productTitle":"product-cell_productTitle_10ZSk"};